import { Button, Form, Offcanvas } from "react-bootstrap";
import { useState } from "react";
import noPreview from "../../Img/noPreview.jpeg";
import { metaServices } from "../../APIServices/VoultManagement/metaServices";

const AddNewOtherImageLibrary = ({ Show, Hide, Title, getMetadataList }) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");
  const [key, setKey] = useState("");

  const [icon, setIcon] = useState("");
  const [iconValue, setIconValue] = useState("");
  const [iconPreview, setIconPreview] = useState("");

  const addNewMetadata = async () => {
    setLoader(true);
    const userData = {
      categoryId: "otherImageLibrary",
      name,
      key,
      icon,
    };
    const data = await metaServices.addNewMetadata(userData);
    if (data?.statusCode === 200) {
      setName("");
      setKey("");
      setIcon("");
      setIconValue("");
      setIconPreview("");
      getMetadataList();
      Hide();
    }
    setLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Key
          </Form.Label>
          <Form.Control
            value={key}
            onChange={(e) => setKey(e.target.value.toLowerCase().replace(/\s+/g, ''))}
            placeholder="Enter Key"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Search Icon
          </Form.Label>
          <Form.Control
            value={iconValue}
            onChange={(e) => {
              const val = e.target.value;
              setIconValue(val);
              if (!val) {
                setIcon("");
                setIconPreview("");
              } else {
                setIconPreview("");
              }
            }}
            placeholder="visa, mastercard..."
            style={{ fontSize: 12 }}
          />
        </Form.Group>
        <Form.Group className="text-center">
          <Form.Label className="fw-bold mb-0" style={{ fontSize: 13 }}>
            OR
          </Form.Label>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Icon URL
          </Form.Label>
          <Form.Control
            value={iconPreview}
            onChange={(e) => {
              setIconPreview(e.target.value);
              setIconValue("");
              setIcon("");
            }}
            placeholder="https://example.com/icon.png"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
        <Form.Group className="mt-4 mb-2 text-center">
          <img
            width="100"
            alt="preview"
            src={
              iconValue
                ? `https://cdn.simpleicons.org/${iconValue}`
                : iconPreview || noPreview
            }
            onLoad={(e) => {
              if (e.target.src !== noPreview) {
                setIcon(e.target.src);
              }
            }}
            onError={(e) => {
              e.target.src = noPreview;
              setIcon("");
            }}
            style={{
              border: "1px solid #ddd",
              borderRadius: 6,
              padding: 6,
              background: "#fff",
            }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || !key || !icon || loader}
          onClick={addNewMetadata}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Saving..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default AddNewOtherImageLibrary;